<template>
  <div>
    <p class="mx-auto d-flex font-weight-medium my-0">
      {{ $t('history') }}
    </p>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              {{ $t('time') }}
            </th>
            <th>
              {{ $t('user') }}
            </th>
            <th>
              {{ $t('description') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td>{{ item.time }}</td>
            <td>{{ item.user.firstname }}   {{item.user.lastname}}</td>
            <td>
              <v-chip
                :color="item.status.color"
                dark
                label
                small
              >
                {{ item.status.name }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
  export default {
    props: ['id', 'type'],
    data () {
      return {
        items: [],
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      getItems () {
        var app = this
        app.isLoading = true
        app.$axios.get(this.$endpoint + 'status/track', {
          params: {
            type: this.type,
            id: this.id,
          },
        })
          .then(res => {
            app.items = [
              ...app.items,
              ...Array.from(res.data.data),
            ]
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
